<template>
  <div id="support-row" style="text-align: center; margin-top: 2em;" class="row">
    <div id="support-row" class="col-12" style="text-align: center;">
      <div style="margin: 10px;">For support, <a href="http:/andrewcarterhughes.com">contact me at my website</a> or <a href="javascript:void(0)" onclick="window.location='mailto:' + String.fromCharCode(97,110,100,114,101,119,64,99,97,114,116,101,114,104,117,103,104,101,115,46,99,111,109) + '?subject=Tibetan-Sanskrit-English Dictionary Support'">email me</a></div>
      <div>Useful Links</div>
      <div><a href="http://uma-tibet.org/">UMA Tibet Institute for Tibetan Studies</a></div>
      <div><a href="https://learntibetanlanguage.org/">Learntibetanlangauge.org - a resource page for studying Tibetan</a></div>
      <div><a href="http://dictionary.christian-steinert.de/#home">Christian Steinert's Tibetan-English Dictionary</a></div>
      <div>Grand Monlam Dictionary 2020 (<a href="https://play.google.com/store/apps/details?id=com.monlamai.monlamgrantdictionary">Android</a>) (<a href="https://apps.apple.com/us/app/monlam-grand-dictionary/id6753943640">iOS</a>)</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupportLinks'
}
</script>
